module.exports = __webpack_public_path__ + "img/telos.25c9180e.png";